import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21de773e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrapper" }
const _hoisted_2 = { class: "df" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = {
  key: 0,
  class: "scroll"
}
const _hoisted_5 = {
  key: 1,
  class: "no-contacts"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_skeleton_contact = _resolveComponent("app-skeleton-contact")!
  const _component_app_contact_item = _resolveComponent("app-contact-item")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, {
      customTitle: _ctx.$localize('group.settings.add.people.header')
    }, {
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
          class: "back-link"
        }, _toDisplayString(_ctx.$localize('group.settings.add.people.backtext')), 1)
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
          class: "back-link"
        }, _toDisplayString(_ctx.$localize('group.settings.add.people.done.button')), 1)
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_search, {
              modelValue: _ctx.driveStore.search,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.driveStore.search) = $event)),
              onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.driveStore.search = ''))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["customTitle"]),
    (!_ctx.driveStore.search)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.dataLoading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_app_skeleton_contact),
                _createVNode(_component_app_skeleton_contact),
                _createVNode(_component_app_skeleton_contact)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.filteredContacts.length)
                  ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
                      ]),
                      main: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredContacts, (contact) => {
                          return (_openBlock(), _createBlock(_component_app_contact_item, {
                            key: contact.accountId,
                            contact: contact,
                            "invited-user-ids": _ctx.invitedUserIds,
                            onInviteToGroup: _ctx.inviteToGroup
                          }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.contacts.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "You don`t have any contacts"))
                  : _createCommentVNode("", true)
              ], 64)),
          (_ctx.isAddingMembers)
            ? (_openBlock(), _createBlock(_component_app_loader, {
                key: 2,
                message: "Adding Members to group"
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "scroll",
          ref: "scroller",
          onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
          (_ctx.myContactsSearch.length)
            ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
                ]),
                main: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myContactsSearch, (contact) => {
                    return (_openBlock(), _createBlock(_component_app_contact_item, {
                      key: contact.accountId,
                      contact: contact,
                      "invited-user-ids": _ctx.invitedUserIds,
                      onInviteToGroup: _ctx.inviteToGroup
                    }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.notMyContactsSearch.length)
            ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 1 }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.other')), 1)
                ]),
                main: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notMyContactsSearch, (contact) => {
                    return (_openBlock(), _createBlock(_component_app_contact_item, {
                      key: contact.accountId,
                      contact: contact,
                      "invited-user-ids": _ctx.invitedUserIds,
                      onInviteToGroup: _ctx.inviteToGroup
                    }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_6
        ], 544))
  ]))
}